const GalleryData = [
    {
      photo: '/assets/images/logos-assessment/assesment1.png',
      title: 'ראש הרשות / מנכ"ל / רמ"ט',
      headline: '1. ראש הרשות / מנכ"ל / רמ"ט',
      text: (
        <>
          <b className="gallery-sub-title">תפקיד ראש הרשות / מנכ"ל / רמ"ט בהערכת מצב:</b>
          <ul>
            <li>מטרה ומיקוד הנושאים המרכזיים בהערכת מצב</li> 
          </ul>
         
        </>
      ),
      video: '/assets/videos/ass1.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment2.png',
      title: 'מבצעים',
      headline: '2. מבצעים',
      text: (
        <><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
          <ul>
            <li> <b>אירועים מרכזיים</b> ברשות וסטאטוס הטיפול בהם.</li>
          <br />
          <li><b>תמ"צ כוחות וצוותים</b> בשטח.</li>
          <br />
          <li><b>סטאטוס מימוש החלטות</b> ראש הרשות / מנכ"ל / הרמ"ט.</li>
          </ul>
        </>
      ),
      video: '/assets/videos/ass2.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment3.png',
      title: 'יקל"ר',
      headline: '3. יקל"ר',
      text: (
        <><b className="gallery-sub-title">תפקיד היקל"ר בהערכת מצב:</b>
        <ul>
          <li><b>תמ"צ צבאית -</b> הערכת האיום, מצב משפטי, תמ"צ כוחות ומאמצים עיקריים בפקע"ר.</li>
          <br />
          <li><b> מדיניות התגוננות –</b> מדיניות נוכחית ותמונת מצב
          מימוש המדיניות ופערים (פיקוח ואכיפה, פגיעה
          בשירותים חיוניים) + ריכוז החרגות הרשות.</li>
          <br />
          <li><b>תמ"צ אוכלוסייה -</b> מגמות אוכלוסייה, צרכים
          והנחיות פיקוד העורף.</li>
          <br />
          <li><b>סטאטוס בקשות הסיוע</b> של הרשות מפקע"ר
          ודרישות סיוע של פקע"ר מהרשות.</li>
        </ul>

        </>
      )
      ,
      video: '/assets/videos/ass3.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment4.png',
      title: 'מכלול אוכלוסיה',
      headline: '4. מכלול אוכלוסיה',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
        <ul>
          <li><b>כשירות המכלול לביצוע משימותיו.</b></li>
          <br />
          <li><b>מגמות התנהגות אוכלוסייה במרחב הרשות וצרכי האוכלוסייה.</b></li>
          <br />
          <li><b>תמ"צ משאבי קהילה והתנדבות -</b> משימות למול משאבים ופערים.</li>
          <br />
          <li><b>תמ"צ רווחה –</b> סטטוס שירותי רווחה ומסגרות למול מדיניות התגוננות.</li>
          <br />
          <li><b>תמ"צ מתקני קליטה</b> (במידה והופעלו) – אוכ' ללא קורת גג, סטטוס נקלטים,
          סטטוס מתקנים, מלונות ופערים.</li>
          <br />
          <li><b>תמ"צ בריאות </b> – סטטוס מתן שירותי רפואה בקהילה למול מדיניות התגוננות.</li>
          <br />
          <li><b> תמ"צ דת –</b> סטטוס שירותי דת למול מדיניות התגוננות והיערכות ללוויות.</li>
          <br />
          <li><b>תמ"צ עלייה וקליטה</b>(במידה וקיים) – עולים במרכזי הקליטה ובקהילה: סטאטוס
          שירותים, צרכים ופערים.
          <br />
          <b>פערים והמלצות</b> לטיפול, סיוע ותמיכה בתושבי הרשות.</li>
        </ul>

      </>),
      video: '/assets/videos/ass4.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment5.png',
      title: 'מכלול חינוך',
      headline: '5. מכלול חינוך',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>כשירות המכלול לביצוע משימותיו.</b></li>
        <br />
        <li><b>תמ"צ לימודים פדגוגי –</b>  אופן ביצוע לימודים למול
        מדיניות התגוננות, מוכנות מוסדות החינוך ופערים.</li>
        <br />
        <li><b>תמ"צ חינוך מיוחד –</b> משמעויות ממדיניות ההתגוננות
        ואופן התמיכה בילדים.</li>
        <br />
        <li><b>תמ"צ חינוך בלתי פורמלי –</b> סטטוס פעילויות חינוכיות
        למול מדיניות התגוננות.</li>
        <br />
        <li><b>תמ"צ מסגרות לילדי עובדים –</b>סטטוס הפעלה ופערים.</li>
        <br />
        <li><b>פערים והמלצות</b> לפעילויות הפגה ופעילויות להספקת
        שירותי חינוך ותמיכה בילדים.</li>
      </ul>
      </>),
      video: '/assets/videos/ass5.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment6.png',
      title: 'מכלול מידע לציבור',
      headline: '6. מכלול מידע לציבור',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>כשירות המכלול לביצוע משימותיו.</b></li>
        <br />
        <li><b>מדד תודעת שירות לתושב –</b> סטטוס המענה לפניות התושבים.</li>
        <br />
        <li><b>תמ"ץ צרכי התושבים –</b> מפלטפורמות הרשות: פילוח פניות ע"פ נושאים
        וקהלי יעד.</li>
        <br />
        <li><b>תמ"ץ מימוש תוכנית ההסברה</b> היומית שסוכמה.</li>
        <br />
        <li><b>המסרים העיקריים לתוכנית הסברה</b> ליממה הקרובה.</li>
        <br />
        <li><b>פערים והמלצות</b> לפעילות הסברה ולפעולות מענה לצרכי התושבים.</li>
      </ul>
      </>),
      video: '/assets/videos/ass6.mp4'
    },
  
    {
      photo: '/assets/images/logos-assessment/assesment7.png',
      title: 'מכלול הנדסה ותשתיות',
      headline: '7. מכלול הנדסה ותשתיות',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>כשירות המכלול לביצוע משימותיו -</b> כ"א, קבלנים,
        חומרים, ציוד הנדסי.</li>
        <br />
        <li><b>תמ"צ תשתיות ומבנים –</b> רמת הפגיעה במבנים ורמת
        הנזק בתשתיות.</li>
        <br />
        <li><b>פעילות לצמצום הסכנות מחומ"ס</b> ומפגעי סביבה.</li>
        <br />
        <li><b>פערים והמלצות לתעדוף</b> לטיפול במבנים ובתשתיות.</li>
      </ul>
      </>),
      video: '/assets/videos/ass7.mp4'
    },
  
    {
      photo: '/assets/images/logos-assessment/assesment8.png',
      title: 'מכלול לוגיסטיקה ותפעול',
      headline: '8. מכלול לוגיסטיקה ותפעול',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>כשירות המכלול לביצוע משימותיו.</b></li>
        <br />
        <li><b>תמ"צ שירותים חיוניים</b> למול מדיניות התגוננות.</li>
        <br />
        <li><b>תמ"צ היסעים, תחבורה וצמ"ה.</b></li>
        <br />
        <li><b>כשירות מחסני החירום</b> למתן מענה רשותי ולהקמת מתקנים.</li>
        <br />
        <li><b>סיוע הניתן למפעלים חיוניים</b> בגזרת הרשות, לפיקוד העורף ולארגוני החירום.</li>
        <br />
        <li><b>פערים והמלצות</b> לרכש, הפעלת חוזים נצורים, ויסות רשותי וסיוע חיצוני.</li>
      </ul>
      </>),
      video: '/assets/videos/ass8.mp4'
    },
  
    {
      photo: '/assets/images/logos-assessment/assesment9.png',
      title: 'מכלול משאבי אנוש ומינהל כללי',
      headline: '9. מכלול משאבי אנוש ומינהל כללי',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>תמ"צ כוח אדם</b> למול צרכי הרשות והמלצות לצמצום הפערים.</li>
        <br />
        <li><b>הנחיות לעובדי הרשות</b> למול מדיניות התגוננות.</li>
        <br />
        <li><b>תמ"צ תיירים וזרים</b> (ברשות שזה רלוונטי - הצגת נתונים ומשמעות). </li>
        <br />
        <li><b>כשירות ואבטחת מערכות התקשוב והמידע.</b></li>
        <br />
        <li><b>פערים והמלצות</b> לפעולות תמיכה בעובדי הרשות.</li>
      </ul>
      </>),
      video: '/assets/videos/ass9.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment10.png',
      title: 'ארגוני חירום וגופי סיוע',
      headline: '10. ארגוני חירום וגופי סיוע',
      text: (<><b className="gallery-sub-title">תפקיד ארגוני חירום וגופי סיוע בהערכת מצב:</b>
      <ul>
        <li><b>תמ"צ טיפול באירועים.</b></li>
        <br />
        <li><b>תמ"צ כוחות בשטח.</b></li>
      </ul>
      </>),
      video: '/assets/videos/ass10.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment11.png',
      title: 'מבצעים',
      headline: '11. מבצעים',
      text: (<><b className="gallery-sub-title">תפקיד המכלול בהערכת מצב:</b>
      <ul>
        <li><b>כשירות המכלול לביצוע תפקידיו.</b></li>
        <br />
        <li><b>תמ"צ מקלטים</b> (ציבוריים ומשותפים) וכשירות צופרים.</li>
        <br />
        <li><b>מדיניות ההתגוננות –</b> משימות מרכזיות למימוש והמלצות.</li>
        <br />
        <li><b>דרישות הרשות לסיוע חיצוני</b> ודרישות גופי החירום מהרשות.</li>
      </ul>
      </>),
      video: '/assets/videos/ass2.mp4'
    },
    {
      photo: '/assets/images/logos-assessment/assesment12.png',
      title: 'ראש הרשות',
      headline: '12. ראש הרשות',
      text: (<>
       <b className="gallery-sub-title">תפקיד ראש הרשות בהערכת מצב:</b>
       <ul>
          <li><b>משימות מרכזיות</b> - תעדוף וטיפול</li>
          <br />
          <li><b> סיכום והנחיות לביצוע</b></li>
       </ul>

      </>),
      video: '/assets/videos/ass1.mp4'
    },
  
  ];

  export default GalleryData;